module.exports = __webpack_public_path__ + "assets/a1f74f1d3054538b575495f242dc279e.png";